var _path, _g, _g2, _path2, _path3, _g3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 195,
    viewBox: "0 0 210 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.696 171.641C146.292 171.641 178.392 139.71 178.392 100.32C178.392 60.9313 146.292 29 106.696 29C67.0993 29 35 60.9313 35 100.32C35 139.71 67.0993 171.641 106.696 171.641Z",
    fill: "#E4E4E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13916_66026)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 100.5,
    r: 59.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13916_66026)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13916_66026)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.042 97.5771V93.9232C143.042 73.4617 126.234 57.3848 106.503 57.3848C86.0418 57.3848 69.9648 74.1925 69.9648 93.9232V97.5771H75.811V93.9232C75.811 77.1155 89.6956 63.2309 106.503 63.2309C123.311 63.2309 137.196 77.1155 137.196 93.9232V97.5771H143.042Z",
    fill: "url(#paint0_linear_13916_66026)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8872 92.4619H76.5411C78.7334 92.4619 80.1949 93.9235 80.1949 96.1158V116.577C80.1949 118.77 78.7334 120.231 76.5411 120.231H72.8872C67.7719 120.231 63.3872 115.847 63.3872 110.731L63.3867 101.962C63.3867 96.8465 67.7713 92.4619 72.8867 92.4619H72.8872Z",
    fill: "#857DF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.195 139.962H124.041C134.272 139.962 142.311 131.923 142.311 121.693V118.77H138.657V121.693C138.657 129.731 132.08 135.577 124.772 135.577H118.926V139.231L118.195 139.962Z",
    fill: "#4251DA",
    fillOpacity: 0.31
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.543 92.4619C78.7353 92.4619 80.1968 93.9235 80.1968 96.1158V116.577C80.1968 118.77 78.7353 120.231 76.543 120.231V92.4619Z",
    fill: "#8459A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.116 92.4619H136.462C134.27 92.4619 132.809 93.9235 132.809 96.1158V116.577C132.809 118.77 134.27 120.231 136.462 120.231H140.116C145.232 120.231 149.616 115.847 149.616 110.731V101.962C149.616 96.8465 145.232 92.4619 140.116 92.4619Z",
    fill: "#857DF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.462 92.4619C134.27 92.4619 132.809 93.9235 132.809 96.1158V116.577C132.809 118.77 134.27 120.231 136.462 120.231V92.4619Z",
    fill: "#8459A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.502 131.923H113.81C116.733 131.923 119.656 134.846 119.656 137.769C119.656 140.692 116.733 143.615 113.81 143.615H106.502C103.579 143.615 100.656 140.692 100.656 137.769C100.656 134.846 103.579 131.923 106.502 131.923Z",
    fill: "#857DF3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.003 90.2695H116.003C120.388 90.2695 124.041 93.9234 124.041 98.308V110C124.041 114.385 120.388 118.039 116.003 118.039H106.503L100.657 123.885C99.9261 124.616 99.1953 123.885 99.1953 123.154V118.039H97.7338C93.3492 118.039 89.6953 114.385 89.6953 110V98.308C89.6953 93.9234 93.3492 90.2695 97.7338 90.2695H97.003Z",
    fill: "#4251DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2954 95.1221H116.421C117.277 95.1221 117.97 95.816 117.97 96.6719C117.97 97.5279 117.277 98.2218 116.421 98.2218H97.2954C96.4397 98.2218 95.7461 97.5279 95.7461 96.6719C95.7461 95.816 96.4397 95.1221 97.2954 95.1221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2954 102.292H116.421C117.277 102.292 117.97 102.986 117.97 103.842C117.97 104.698 117.277 105.392 116.421 105.392H97.2954C96.4397 105.392 95.7461 104.698 95.7461 103.842C95.7461 102.986 96.4397 102.292 97.2954 102.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.2954 109.462H107.459C108.314 109.462 109.008 110.156 109.008 111.012C109.008 111.868 108.314 112.562 107.459 112.562H97.2954C96.4397 112.562 95.7461 111.868 95.7461 111.012C95.7461 110.156 96.4397 109.462 97.2954 109.462Z",
    fill: "white"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M32.8158 37.5787C38.9143 37.5787 43.8582 32.6439 43.8582 26.5564C43.8582 20.469 38.9143 15.5342 32.8158 15.5342C26.7173 15.5342 21.7734 20.469 21.7734 26.5564C21.7734 32.6439 26.7173 37.5787 32.8158 37.5787Z",
    fill: "url(#paint1_linear_13916_66026)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M173.798 175.442C176.493 175.442 178.678 173.257 178.678 170.562C178.678 167.867 176.493 165.683 173.798 165.683C171.103 165.683 168.918 167.867 168.918 170.562C168.918 173.257 171.103 175.442 173.798 175.442Z",
    fill: "url(#paint2_linear_13916_66026)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.511788,
    filter: "url(#filter2_f_13916_66026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8001 187.454C63.7266 187.454 75.8269 175.354 75.8269 160.427C75.8269 145.501 63.7266 133.4 48.8001 133.4C33.8737 133.4 21.7734 145.501 21.7734 160.427C21.7734 175.354 33.8737 187.454 48.8001 187.454Z",
    fill: "url(#paint3_linear_13916_66026)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.511788,
    d: "M174.172 46.3149C184.952 46.3149 193.691 37.5759 193.691 26.7957C193.691 16.0154 184.952 7.27637 174.172 7.27637C163.391 7.27637 154.652 16.0154 154.652 26.7957C154.652 37.5759 163.391 46.3149 174.172 46.3149Z",
    fill: "url(#paint4_linear_13916_66026)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13916_66026",
    x: 25,
    y: 22,
    width: 163,
    height: 163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.427451 0 0 0 0 0.537255 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13916_66026"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13916_66026",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13916_66026",
    x: 55.9867,
    y: 49.3248,
    width: 101.03,
    height: 101.03,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.66
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.427451 0 0 0 0 0.537255 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13916_66026"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13916_66026",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_13916_66026",
    x: 18.7705,
    y: 130.397,
    width: 60.0606,
    height: 60.0596,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.50148,
    result: "effect1_foregroundBlur_13916_66026"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13916_66026",
    x1: 106.281,
    y1: 121.463,
    x2: 106.281,
    y2: 54.5615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4251DA",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13916_66026",
    x1: 21.3799,
    y1: 42.9772,
    x2: 36.834,
    y2: 13.4457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13916_66026",
    x1: 168.744,
    y1: 177.832,
    x2: 175.593,
    y2: 164.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13916_66026",
    x1: 20.8103,
    y1: 200.691,
    x2: 58.7432,
    y2: 128.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13916_66026",
    x1: 153.957,
    y1: 55.8751,
    x2: 181.353,
    y2: 3.61899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13916_66026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 95,
    fill: "white",
    transform: "translate(59 53)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon-support.7f291d1b1e2a18cc2e5baaedb5f7a315.svg";
export { ForwardRef as ReactComponent };